import { Link } from 'react-router';
import type { TeacherDestination } from '../../data/teacherDestinations';

export default function TeacherCard({ destination }: { destination: TeacherDestination }) {
  return (
    <Link
      to={destination.route}
      className="teacher-card"
      style={{
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--navy-800)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        padding: '48px 24px',
        minHeight: 170,
        transition: 'box-shadow var(--transition-base), transform var(--transition-base)',
      }}
    >
      <span
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: 'var(--text-on-dark)',
          fontFamily: 'var(--font-display)',
          textAlign: 'center',
        }}
      >
        {destination.label}
      </span>
    </Link>
  );
}
